import { OperatorContextModel } from './operator-context.model';

export class UserContextModel {
  public id;
  public name;
  public accountId;
  public operatorContext;

  constructor() {
    this.id = null;
    this.name = null;
    this.accountId = null;

    this.operatorContext = new OperatorContextModel();
  }
}
